import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import styles from 'styles/jss/original/components/shoppings/detailAction';
import { IShopping } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  shopping: IShopping;
};

const DetailAction: React.FC<ComponentProps> = ({ shopping }) => {
  const { siteUrl } = shopping.fields;
  const classes = useStyles();

  return (
    <div className={classes.box}>
      <a href={siteUrl} target='_blank' rel='noopener noreferrer'>
        {/* @ts-expect-error */}
        <Button round color='danger'>
          <ShoppingCart /> &nbsp; 購入サイトへ
        </Button>
      </a>
    </div>
  );
};

export default DetailAction;
